'use client';

import { useRef, useState } from 'react';

import { Play } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { cn } from '@kit/ui/utils';

/** Poster image with a round play button; the bundled clip loads only after the visitor presses play. */
export function SplitVideo({ src, poster, title, className }: { src: string; poster?: string; title: string; className?: string }) {
  const { t } = useTranslation();
  const [playing, setPlaying] = useState(false);
  const video = useRef<HTMLVideoElement>(null);

  if (playing) {
    return (
      <video
        ref={video}
        src={src}
        poster={poster}
        controls
        autoPlay
        playsInline
        preload="metadata"
        className={cn('w-full bg-black object-cover', className)}
        aria-label={title}
      />
    );
  }

  return (
    <button type="button" className="group relative block w-full" onClick={() => setPlaying(true)} data-test="landing-split-video-play">
      {/* eslint-disable-next-line @next/next/no-img-element */}
      {poster ? <img src={poster} alt="" loading="lazy" className={cn('w-full object-cover', className)} /> : <span className={cn('block w-full bg-neutral-900', className)} />}
      <span className="absolute inset-0 flex items-center justify-center">
        <span className="flex h-20 w-20 items-center justify-center rounded-full bg-white/90 text-primary shadow-lg transition-transform motion-safe:group-hover:scale-105">
          <Play className="ms-1 h-8 w-8 fill-current" aria-hidden />
        </span>
      </span>
      <span className="sr-only">{t('marketing:landingPlayVideo', { title })}</span>
    </button>
  );
}
